import { Component } from '@angular/core';

import { Platform, ModalController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { version } from '../../package.json';

import { timer } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  navigate: any;
  public version: string = version;

  showSplash = true;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private modalCtl: ModalController
  ) {
    this.initializeApp();
    this.sideMenu();
  }

  ngOnInit() {}

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      timer(4000).subscribe(() => this.showSplash = false)
    });
  }

  sideMenu() {
    this.navigate = [
      {
        title: "Home",
        url: "/",
        icon: "home"
      },
      {
        title: "Pre-Set Packs",
        url: "/packs",
        icon: ""
      },
      {
        title: "Build your own",
        url: "/calculator",
        icon: ""
      },
    ];
  }
}
